export default __webpack_public_path__ + "static/media/Q0007.1c999a30.png";